import SectionsLoaderEdit from '../Edit/SectionsLoader';
import SectionsLoader from '../New/SectionsLoader';
import { useReadyBuilder } from './useReadyBuilder';

interface Props {
  stateKind: 'new' | 'edit' | 'preview';
}

function Section({ stateKind }: Props) {
  const { resourceState } = useReadyBuilder();
  const productCollection = resourceState.payload.product_collections;

  switch (stateKind) {
    case 'new':
      return <SectionsLoader product_collections={productCollection} />;
    case 'edit':
      // selectedDates is now managed by LearningCollectionContext and synced
      // from resourceState.payload.scheduled_programs automatically
      return <SectionsLoaderEdit product_collections={productCollection} stateKind="edit" />;
    case 'preview':
      // DVLP-7601: read-only render of the same section chain — no
      // AddSections buttons, no edit affordances on cards.
      return <SectionsLoaderEdit product_collections={productCollection} stateKind="preview" />;
  }
}

export default Section;
